import { render, staticRenderFns } from "./cancel-errand.vue?vue&type=template&id=dd0d952e"
import script from "./cancel-errand.vue?vue&type=script&lang=js"
export * from "./cancel-errand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports